import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StyledSlash } from './styled';

export const Slash: ReactFCV<IBasicStyledProps> = ({ ...rest }) => <StyledSlash {...rest} />;
